module.exports = __webpack_public_path__ + "static/media/people.1439f067.svg";